/* eslint-disable @typescript-eslint/naming-convention */
import { InitialDeficiency } from '../constants';
export default function generateBaseNewDeficiency(params) {
    var _a, _b;
    return Object.assign(Object.assign({}, InitialDeficiency), { page_no: (_a = params === null || params === void 0 ? void 0 : params.page.toString()) !== null && _a !== void 0 ? _a : null, description: (_b = params === null || params === void 0 ? void 0 : params.text) !== null && _b !== void 0 ? _b : null, deficiency_uid: null, isManuallyAdded: true });
}
